import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '../components/ui/Button';
import { Card, CardContent } from '../components/ui/Card';
export function ViewEmailDetail() {
  const navigate = useNavigate();
  return <div className="space-y-4" data-id="element-2468">
      <div className="flex items-center justify-between" data-id="element-2469">
        <h1 className="text-2xl font-bold text-slate-900" data-id="element-2470">Email Detail</h1>
        <Button variant="secondary" size="sm" className="border border-slate-300 bg-gradient-to-b from-white to-slate-100 text-slate-700 shadow-sm" onClick={() => navigate('/email-details')} data-id="element-2471">
          ← Back to Email Details
        </Button>
      </div>

      <Card data-id="element-2472">
        <CardContent className="pt-6" data-id="element-2473">
          <table className="text-sm w-full" data-id="element-2474">
            <tbody data-id="element-2475">
              <tr className="border-b border-slate-100" data-id="element-2476">
                <td className="py-2 pr-6 font-medium text-slate-700 w-24 align-top" data-id="element-2477">
                  Id
                </td>
                <td className="py-2 text-slate-900" data-id="element-2478">1</td>
              </tr>
              <tr className="border-b border-slate-100" data-id="element-2479">
                <td className="py-2 pr-6 font-medium text-slate-700 align-top" data-id="element-2480">
                  Subject
                </td>
                <td className="py-2 text-slate-900" data-id="element-2481">
                  Welcome to Desert Sage Seminars
                </td>
              </tr>
              <tr className="border-b border-slate-100" data-id="element-2482">
                <td className="py-2 pr-6 font-medium text-slate-700 align-top" data-id="element-2483">
                  Body
                </td>
                <td className="py-4 text-slate-800 leading-relaxed max-w-2xl" data-id="element-2484">
                  <div className="space-y-3" data-id="element-2485">
                    <p data-id="element-2486">
                      You have received this notification from{' '}
                      <a href="#" className="text-blue-600 underline" data-id="element-2487">
                        Desert Sage Seminars
                      </a>{' '}
                      because you are a registered user. You have successfully
                      registered with Desert Sage Seminars.{' '}
                      <span className="bg-yellow-200 font-bold" data-id="element-2488">
                        PLEASE SAVE THIS EMAIL FOR YOUR RECORDS.
                      </span>
                    </p>
                    <p data-id="element-2489">
                      Your Username and Password will enable you to enroll in
                      our courses at any time.
                    </p>
                    <p data-id="element-2490">Your Username is as follows:</p>
                    <table className="border border-slate-300 text-sm" data-id="element-2491">
                      <tbody data-id="element-2492">
                        <tr data-id="element-2493">
                          <td className="border border-slate-300 px-3 py-1 font-medium" data-id="element-2494">
                            Username:
                          </td>
                          <td className="border border-slate-300 px-3 py-1" data-id="element-2495">
                            username
                          </td>
                        </tr>
                      </tbody>
                    </table>
                    <p data-id="element-2496">
                      Please remember that the Password you created is case
                      sensitive.
                    </p>
                    <p data-id="element-2497">You affirmed the following to be true:</p>
                    <ul className="list-disc pl-6 space-y-1 font-bold" data-id="element-2498">
                      <li data-id="element-2499">I will be the person taking these classes, and</li>
                      <li data-id="element-2500">
                        I realize that it is a felony to impersonate a real
                        estate licensee
                      </li>
                      <li data-id="element-2501">
                        I will not complete more than 9 renewal hours within the
                        same calendar day
                      </li>
                    </ul>
                    <p data-id="element-2502">
                      At any time while taking a course, you will be able to
                      contact Tech Support* should you encounter a problem with
                      our website, or Course Support* should you encounter any
                      issues with the course, the text, quizzes or anything
                      course related.
                    </p>
                    <p data-id="element-2503">
                      * Support will be available 7 days a week from 7:30 AM to
                      9:00 PM Arizona time.
                    </p>
                    <p data-id="element-2504">
                      Thank you for registering with Desert Sage Seminars. We
                      are sure you will find our courses to be an efficient and
                      valuable use of your time.
                    </p>
                    <p data-id="element-2505">Cordially</p>
                    <p className="font-bold" data-id="element-2506">
                      Jon Kichen, Instructor
                      <br data-id="element-2507" />
                      Owner/Administrator
                      <br data-id="element-2508" />
                      Desert Sage Seminars
                      <br data-id="element-2509" />
                      Phone: 602-377-6207
                      <br data-id="element-2510" />
                      URL: www.DesertSageSeminars.com
                    </p>
                  </div>
                </td>
              </tr>
              <tr className="border-b border-slate-100" data-id="element-2511">
                <td className="py-2 pr-6 font-medium text-slate-700" data-id="element-2512">Param</td>
                <td className="py-2 text-slate-900 font-mono text-xs" data-id="element-2513">
                  sign_in_confirmation
                </td>
              </tr>
              <tr className="border-b border-slate-100" data-id="element-2514">
                <td className="py-2 pr-6 font-medium text-slate-700" data-id="element-2515">
                  Created
                </td>
                <td className="py-2 text-slate-900" data-id="element-2516">2011-09-26 12:39:36</td>
              </tr>
            </tbody>
          </table>

          <div className="mt-6 pt-4 border-t border-slate-200 space-y-1" data-id="element-2517">
            <p className="text-sm font-medium text-slate-700" data-id="element-2518">Actions</p>
            <div className="flex flex-col gap-1 text-sm text-blue-600" data-id="element-2519">
              <button className="text-left hover:underline w-fit" onClick={() => navigate('/email-details/edit/1')} data-id="element-2520">
                Edit Email Detail
              </button>
              <button className="text-left hover:underline text-red-500 w-fit" data-id="element-2521">
                Delete Email Detail
              </button>
              <button className="text-left hover:underline w-fit" onClick={() => navigate('/email-details')} data-id="element-2522">
                List Email Details
              </button>
              <button className="text-left hover:underline w-fit" data-id="element-2523">
                New Email Detail
              </button>
            </div>
          </div>
        </CardContent>
      </Card>
    </div>;
}